import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';
import { USER_TYPES } from '../../../services/user';
import { QuestionnaireTypes } from '../../../services/questionnaires';
import { isWorkspaceCoveredStatus } from './workspaceDerivations';

// v2 applies only under /assessment/:assessmentId for assessors/TPN admins on the MPA Best Practice questionnaire during Assessing/Submitted; everyone else keeps the existing UI.
export function useAssessmentVariant(): boolean {
  const params = useParams();
  const { user } = useAppSelector(state => state.user);
  const { questionnaire, assessmentStatus } = useAppSelector(state => state.questionnaireAnswer);

  if (!params.assessmentId) return false;
  if (user?.type !== USER_TYPES.ASSESSOR && user?.type !== USER_TYPES.TPN_ADMIN) return false;
  if (!isWorkspaceCoveredStatus(assessmentStatus)) return false;
  return !questionnaire || questionnaire.type === QuestionnaireTypes.MPA_BEST_PRACTICE;
}


// True while the variant decision's inputs load — callers hold the classic chrome (never render the workspace early).
export function useAssessmentVariantPending(): boolean {
  const params = useParams();
  const { user } = useAppSelector(state => state.user);
  const { assessmentStatus } = useAppSelector(state => state.questionnaireAnswer);

  if (!params.assessmentId) return false;
  if (user?.type !== USER_TYPES.ASSESSOR && user?.type !== USER_TYPES.TPN_ADMIN) return false;
  return !assessmentStatus;
}
